import { render, staticRenderFns } from "./DataMobil.vue?vue&type=template&id=33d781a1&"
import script from "./DataMobil.vue?vue&type=script&lang=js&"
export * from "./DataMobil.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports